export default __webpack_public_path__ + "static/media/i_bus-dbl_bl.ddf760dd.svg";